// import Vue from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
// import vuetify from './plugins/vuetify'
// import Toast from "vue-toastification";
// import axios from 'axios';
// import "@fontsource/roboto/100.css";
// import "@fontsource/roboto/300.css";
// import "@fontsource/roboto/400.css";
// import "@fontsource/roboto/500.css";
// import "@fontsource/roboto/700.css";
// import "@fontsource/roboto/900.css";
// import "@mdi/font/css/materialdesignicons.min.css";
// import { loadConfig, getConfig } from "./services/configService";

// // Import the CSS or use your own!
// import "vue-toastification/dist/index.css";
// import * as VueGoogleMaps from "vue2-google-maps" // Import package
// import VueOffline from 'vue-offline';
// import VueGoogleDistance from 'vue-google-distance';
// import VueTouchKeyboard from "vue-touch-keyboard";
// import * as Cookies from 'js-cookie'; //Importa cookies
// /*eslint-disable */
// import style from "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style
// /*eslint-enable */




// fetch('/config.json')
// .then(res => res.json())
// .then(config => {
//     axios.defaults.baseURL = config.api_backend_route;

    

// axios.interceptors.request.use(config => {
//   // lee las cookies o el store para poner los headers esperados
//   const empresa = Cookies.get('POS_EMPRESA') || '0';
//   const sucursal = Cookies.get('POS_SUCURSAL') || '0';
//   // const usuario = Cookies.get('POS_USER') || '';
//   const usuario = Cookies.get('POS_USER')?.trim() || '';
//   const terminal = Cookies.get('POS_TERMINAL') || '';
//   const tipo = Cookies.get('POS_TIPO') || '';
//   const register = Cookies.get('POS_REGISTER_CAJA') || '0';

//   config.headers['empresa'] = empresa;
//   config.headers['sucursal'] = sucursal;
//   config.headers['usuario'] = usuario;
//   config.headers['terminal'] = terminal;
//   config.headers['tipo'] = tipo;
//   config.headers['register'] = register;

//   return config;
// }, error => {
//   return Promise.reject(error);
// });



//     Vue.use(VueTouchKeyboard);
//     Vue.use(VueGoogleMaps, {
//       load: {
//         key: config.google_key,
//         libraries: "places"
//       }
//     });
//     Vue.use(VueGoogleDistance);

//   Vue.prototype.$config = config;
//   Vue.use(VueOffline)
//   Vue.use(Toast, {

//   });

//   Vue.config.productionTip = false
//   const host = window.location.host ;
//   const parts = host.split('.');
//   const domainLength = parts.length; // route1.example.com => domain length = 3
//   if (domainLength == 3) {
//     Vue.prototype.$client = parts[0];
//   }else {
//     Vue.prototype.$client = "N/A";
//   }

//   new Vue({
//     router,
//     store,
//     vuetify,
//     render: h => h(App)
//   }).$mount('#app')
  
// })

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Toast from "vue-toastification";
import axios from 'axios';
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import "@mdi/font/css/materialdesignicons.min.css";
import { loadConfig, getConfig } from "./services/configService";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import * as VueGoogleMaps from "vue2-google-maps" // Import package
import VueOffline from 'vue-offline';
import VueGoogleDistance from 'vue-google-distance';
import VueTouchKeyboard from "vue-touch-keyboard";
import * as Cookies from 'js-cookie'; //Importa cookies
/*eslint-disable */
import style from "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style
/*eslint-enable */

Vue.config.productionTip = false

async function bootstrap() {
  
  await loadConfig();
  const config = getConfig();

  
  axios.defaults.baseURL = config.api_backend_route;

  axios.interceptors.request.use(configReq => {
    const empresa = Cookies.get('POS_EMPRESA') || '0';
    const sucursal = Cookies.get('POS_SUCURSAL') || '0';
    const usuario = Cookies.get('POS_USER')?.trim() || '';
    const terminal = Cookies.get('POS_TERMINAL') || '';
    const tipo = Cookies.get('POS_TIPO') || '';
    const register = Cookies.get('POS_REGISTER_CAJA') || '0';

    configReq.headers['empresa'] = empresa;
    configReq.headers['sucursal'] = sucursal;
    configReq.headers['usuario'] = usuario;
    configReq.headers['terminal'] = terminal;
    configReq.headers['tipo'] = tipo;
    configReq.headers['register'] = register;

    return configReq;
  }, error => {
    return Promise.reject(error);
  });

  Vue.use(VueTouchKeyboard);

  Vue.use(VueGoogleMaps, {
    load: {
      key: config.google_key,
      libraries: "places"
    }
  });

  Vue.use(VueGoogleDistance);

  Vue.prototype.$config = config;
  Vue.use(VueOffline)

  Vue.use(Toast, {});

  const host = window.location.host;
  const parts = host.split('.');
  const domainLength = parts.length;

  if (domainLength == 3) {
    Vue.prototype.$client = parts[0];
  } else {
    Vue.prototype.$client = "N/A";
  }

  
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap();